























































































import { Mixins, Component } from "vue-property-decorator";
import { DialogMixin } from "../../../../../../../base/components/system/mixins";
import { ObjectUtility } from "../../../../../../../base/utilities";
import { IJoinedTextItem } from "../../../../../../../documaker/domain/format/objects";
import { IFormatObjectEditable } from "../../../../../../../formatEditor/domain/editableFormat";
import { TextJoinItemSelector } from "../selectors";

@Component({
  components: {
    TextJoinItemSelector
  }
})
export default class TextJoinItemEditDialog extends Mixins(DialogMixin) {
  items: IJoinedTextItem[] = [];
  selectionObjects: IFormatObjectEditable[] = [];
  selectedItems: IJoinedTextItem[] = [];
  selectedObjects: IJoinedTextItem[] = [];
  edittingJoinedString: string = "";
  confirmed: boolean = false;

  filteres: {
    enabled: boolean;
    name: string;
    description: string;
    filter: (v: IFormatObjectEditable) => boolean;
  }[] = [
    { enabled: false, name: "テキスト", description: "テキストで絞り込みします",
      filter: v => {
        switch (v.objectTypeName().getValue()) {
          case "text":
          case "tag":
            return true;
          default:
            return false;
        }
      }
    },
    { enabled: false, name: "リスト", description: "リストで絞り込みします",
      filter: v => v.objectTypeName().getValue() === "combo" },
  ];

  get filteredObjects(): IFormatObjectEditable[] {
    return this.filteres.some(f => f.enabled)
      ? this.selectionObjects.filter(o => this.filteres.some(f => f.enabled && f.filter(o)))
      : this.selectionObjects;
  }

  get filteredJoinedTextItems(): IJoinedTextItem[] {
    return this.filteredObjects.map(v => this.createJoinedTextItem(v));
  }

  private createJoinedTextItem(value: IFormatObjectEditable): IJoinedTextItem {
    return {
      isObject: true,
      reference: value.toLinkedObjectIdentifier(),
    };
  }

  get hasEdittingJoinedString(): boolean {
    return this.edittingJoinedString !== "";
  }

  get hasSelectedItems(): boolean {
    return this.selectedItems.length > 0;
  }

  get isTopSelectedItem(): boolean {
    return this.hasSelectedItems && this.selectedItems.some(v => v === this.items[0]);
  }

  get isBottomSelectedItem(): boolean {
    return this.hasSelectedItems && this.selectedItems.some(v => v === this.items[this.items.length - 1]);
  }

  get hasSelectedObjects(): boolean {
    return this.selectedObjects.length > 0;
  }

  async show(
    items: IJoinedTextItem[],
    selectionObjects: IFormatObjectEditable[]): Promise<IJoinedTextItem[]> {
    return this.showModal(async () => {
      this.items = ObjectUtility.copyDeeply(items);
      this.selectionObjects = selectionObjects;
      this.selectedItems = [];
      this.selectedObjects = [];
      this.edittingJoinedString = "";
      this.confirmed = false;
      await this.waitHidden();
      return this.confirmed ? this.items : null;
    });
  }

  addJoinedString() {
    this.items = this.items.concat({
      isObject: false,
      reference: {
        value: this.edittingJoinedString,
      },
    });
  }

  addJoinedObjects() {
    this.items = this.items.concat(ObjectUtility.copyDeeply(this.selectedObjects));
  }

  moveItems(offset: number) {
    const indexes = this.selectedItems.map(v => this.items.indexOf(v)).sort((a, b) => a - b);
    if (offset > 0) {
      indexes.reverse();
    }
    indexes.forEach(i => this.moveItem(i, offset));
  }

  private moveItem(index: number, offset: number) {
    const item = this.items[index];
    this.items.splice(index, 1);
    this.items.splice(index + offset, 0, item);
  }

  removeItems() {
    this.items = this.items.filter((v) => !this.selectedItems.some(s => s === v));
  }

  changeItems(value: IJoinedTextItem[]) {
    this.selectedItems = value;
  }

  changeObjects(value: IJoinedTextItem[]) {
    this.selectedObjects = value;
  }

  confirm(): void {
    this.confirmed = true;
    this.isVisible = false;
  }

  cancel(): void {
    this.isVisible = false;
  }
}
